import Icon from '@mdi/react'
import type { IconProps } from '.'

const contactSupportSvg = `M11 23.59v-3.6c-5.01-.26-9-4.42-9-9.49C2 5.26 6.26 1 11.5 1S21 5.26 21 10.5c0 4.95-3.44 9.93-8.57 12.4zM11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3m-1 11.5h2v2h-2zm2-1.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5`

const ContactSupport = (props: IconProps) => {
    const { color, filled, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="Icon__ContactSupport"
            path={contactSupportSvg}
            size={size}
            color={color}
            {...(title ? { title } : {})}
            {...other}
        />
    )
}

export default ContactSupport
